import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
  selector: 'app-select-agent-dialog',
  templateUrl: './select-agent-dialog.component.html',
  styleUrls: ['./select-agent-dialog.component.css']
})
export class SelectAgentDialogComponent implements OnInit {

  selection: object;
  agentList: object[];

  constructor(private dialogRef: MatDialogRef<SelectAgentDialogComponent>,
@Inject(MAT_DIALOG_DATA) data) {
  this.agentList = data.list;
  this.selection = data.agent;
}

  ngOnInit() {
  }


  save() {
    console.log("Selected agent is ", this.selection);
    if(this.selection == undefined){
      console.log("Agent is needed");
        return;
    }
    this.dialogRef.close(this.selection);
  }

    close() {
        this.dialogRef.close();
}

}
